import {
  SchoolAccessDialog,
  canExploreSchoolAccess,
} from "../features/help/SchoolAccessDialog";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthenticationStore } from "../stores/auth";
import { useHelpStore } from "../stores/help";
import { QuickStartDemoDialog } from "../shared-components/QuickStartDemoDialog";
import { ContextualHelpDialog } from "../features/help/ContextualHelpDialog";
import { canOpenQuickStart, helpOwner } from "../features/help/contextualHelp";

import { IntroductionTrigger } from "../features/help/IntroductionTrigger";
import { SignupIntroductionDialog } from "../features/help/SignupIntroductionDialog";
import { canOpenIntroduction } from "../features/help/signupPurpose";

export const HelpBox = ({ blocked = false }) => {
  const { user } = useAuthenticationStore();
  const { pathname } = useLocation();
  const { panel, owner, close, openQuickStart, openIntroduction } =
    useHelpStore();
  const currentOwner = helpOwner(user);
  const eligible = canOpenQuickStart(user);
  const allowed = user?.isLoggedIn && owner === currentOwner && !blocked;

  useEffect(() => {
    if (
      panel &&
      (!allowed ||
        (panel === "school-access" && !canExploreSchoolAccess(user)) ||
        (panel === "quick-start" && !eligible) ||
        (panel === "introduction" && !canOpenIntroduction(user)))
    )
      close();
  }, [allowed, panel, eligible, close, user]);
  useEffect(() => () => close(), [close]);

  const trigger =
    user?.signInSession &&
    !user.introductionSeen &&
    canOpenIntroduction(user) ? (
      <IntroductionTrigger
        user={user}
        blocked={blocked}
        pathname={pathname}
        panel={panel}
      />
    ) : null;
  if (!allowed) return trigger;
  if (panel === "introduction" && canOpenIntroduction(user))
    return (
      <SignupIntroductionDialog
        key={currentOwner}
        user={user}
        onClose={close}
        onQuickStart={openQuickStart}
      />
    );
  if (panel === "school-access" && canExploreSchoolAccess(user))
    return <SchoolAccessDialog onClose={close} />;
  if (panel === "help")
    return (
      <ContextualHelpDialog
        user={user}
        pathname={pathname}
        onClose={close}
        onQuickStart={openQuickStart}
        onGettingStarted={openIntroduction}
      />
    );
  if (panel === "quick-start" && eligible)
    return <QuickStartDemoDialog key={currentOwner} open onClose={close} />;
  return trigger;
};
